import * as Website from '../../Config/Website.js';
import CardStack from '../../Modules/CardStack.js';
import { SideScrollSP, SideScrollSPResize } from '../../Modules/SideScroll.js';
import TabSwitch from '../../Modules/TabSwitch.js';
import MaskScroll, { MaskScrollResize } from '../../Modules/MaskScroll.js';
import ScrollToggle from '../../Modules/ScrollToggle.js';
import ViewStack from '../../Modules/ViewStack.js';


const preinit = () => {

}

const init = () => {
  CardStack();
  SideScrollSP();
  TabSwitch();
  MaskScroll();
  ScrollToggle();
  ViewStack();
}

const resize = () => {

}

const resizeW = () => {
  SideScrollSPResize();
  MaskScrollResize();
}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}